import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 3),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
}));

const AddOrUpdatePartner = (props) => {
  const classes = useStyles();
  const {
    handleButtonClick,
    action,
    handleChange,
    addAnother,
    handleAddAnother,
  } = props;

  const initialState = {
    partner: {},
  };

  const [state, setState] = useState(initialState);

  const { partner } = state;

  const { name } = partner;

  const isEmpty = (data) => {
    let response = true;
    if (data) {
      response = false;
    }
    return response;
  };

  const isValidData = !isEmpty(name);

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const partner = { ...state.partner, [name]: value };
    setState((prevState) => ({
      ...prevState,
      partner,
    }));
  };

  useEffect(() => {
    const { partner } = props;
    setState((prevState) => ({
      ...prevState,
      partner,
    }));
  }, [props.partner]);

  return (
    <div>
      <Dialog
        open={!(action === "Close")}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <DialogContent>
          <div>
            <Paper className={classes.paper}>
              <Grid container spacing={3}>
                <Grid item xs>
                  <b>{action} Partner</b>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs>
                  <TextField
                    error={isEmpty(name)}
                    helperText={isEmpty(name) ? "Required." : ""}
                    margin="dense"
                    name="name"
                    id="name"
                    label="Partner Name"
                    type="text"
                    onChange={handleInput}
                    value={name ?? ""}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs>
                  <Grid container spacing={3}>
                    <Grid item xs>
                      {action === "Add" && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={addAnother}
                              onChange={handleAddAnother}
                              name="addAnother"
                              color="primary"
                            />
                          }
                          label="Add another"
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs>
                  <Grid container spacing={3}>
                    <Grid item xs>
                      <Button
                        onClick={() => {
                          handleButtonClick(`Close`);
                        }}
                        color="primary"
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item xs>
                      {action === "Add" && (
                        <Button
                          onClick={() => {
                            handleChange(partner);
                          }}
                          color="primary"
                          variant="outlined"
                          disabled={!isValidData}
                        >
                          Save
                        </Button>
                      )}
                      {action === "Update" && (
                        <Button
                          onClick={() => {
                            handleChange(partner);
                          }}
                          color="primary"
                          variant="outlined"
                          disabled={!isValidData}
                        >
                          Update
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "0px" }}></DialogActions>
      </Dialog>
    </div>
  );
};
export default AddOrUpdatePartner;
